import React, { useEffect, useState } from "react";
import {
  AddFlex,
  CreateInstaAutomationInput,
  CustomInput,
  CustomText,
  DialogHeader,
} from "../../reusableStyles";
import CreateUpdateInstaCommentAutomation from "./CreateUpdateInstaCommentAutomation";
import { Button, Checkbox, Divider, Radio, Tag } from "antd";
import useDialogActionsHook from "../../CustomHooks.js/useDialogActionsHook";
import DialogWrapper from "../../DialogWrapper";
import TextArea from "antd/es/input/TextArea";
import { primaryActionColor } from "../../constants";
import { isStringNullOrUndefined } from "../../utils";
import { enqueueSnackbar } from "notistack";

function ReplyToCommentsAutomationData({
  index,
  errors,
  disabled,
  automation,
  otherAutomationsData,
  setOtherAutomationsData,
}) {
  const [body, setBody] = useState(otherAutomationsData?.body);
  const [context, setContext] = useState(
    otherAutomationsData?.body?.context || ""
  );
  const { openDialog, isDialogOpen, closeDialog } = useDialogActionsHook();
  useEffect(() => {
    console.log("called");
    setOtherAutomationsData((prev) =>
      prev.map((item, _index) => {
        if (_index === index) {
          return { ...item, body };
        } else {
          return item;
        }
      })
    );
  }, [body]);
  return (
    <>
      <AddFlex
        flexDirection="column"
        gap="8px"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <CustomText fontSize="14px">{automation.subText}</CustomText>
        {errors["reply-to-comments-data"] && (
          <CustomText fontSize="14px" color="red">
            {errors["reply-to-comments-data"]}
          </CustomText>
        )}
        <Divider style={{ margin: "0px 0px" }} />
        <AddFlex
          flexDirection="column"
          gap="6px"
          onClick={() => {
            if (disabled) {
              return;
            }
            if (body.isAi) {
              const array = new Array(7).fill("");
              setBody(array);
            }
          }}
        >
          <AddFlex
            gap="5px"
            // style={{ borderTop: "1px solid #ececec", paddingTop: "5px" }}
          >
            <Radio checked={!body.isAi} />
            <label>Predefined Reply to comments</label>
          </AddFlex>
          {!body.isAi &&
            body.map((item, index) => (
              <CreateInstaAutomationInput
                value={item}
                disabled={disabled}
                onChange={(e) => {
                  setBody((prev) =>
                    prev.map((item, _index) => {
                      if (_index === index) {
                        return e.target.value;
                      } else {
                        return item;
                      }
                    })
                  );
                }}
                placeholder={"Write a reply"}
              />
            ))}
        </AddFlex>
        <Divider style={{ margin: "5px 0px" }} />
        <AddFlex flexDirection="column" gap="8px">
          <AddFlex
            gap="5px"
            alignItems="flex-start"
            // style={{ borderTop: "1px solid #ececec", paddingTop: "5px" }}
            onClick={() => {
              if (disabled) {
                return;
              }
              setBody({ isAi: true, context });
            }}
          >
            <Radio checked={body.isAi} />
            <AddFlex flexDirection="column">
              <label>Allow AI to reply to comments.</label>
              {!isStringNullOrUndefined(body.context) && (
                <CustomText color="green" fontSize="12px" fontWeight="500">
                  AI Context Added
                </CustomText>
              )}
            </AddFlex>
            <Tag color="blue">Pro</Tag>
          </AddFlex>
          <Button
            style={{ width: "max-content" }}
            onClick={openDialog}
            disabled={disabled}
          >
            Define AI Reply Context
          </Button>
        </AddFlex>
      </AddFlex>
      <DialogWrapper
        width={"50vw"}
        open={isDialogOpen}
        closeDialog={closeDialog}
        component={
          <AddFlex
            flexDirection="column"
            padding="20px"
            gap="20px"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <DialogHeader
              mainText={"Give some context to the AI"}
              onClose={closeDialog}
              subText={
                "Give complete details of the post here, so that AI can reply to any queries asked in the comments section"
              }
            />
            <TextArea
              rows={10}
              value={context}
              style={{ resize: "none" }}
              onChange={(e) => {
                setContext(e.target.value);
              }}
              placeholder="Explain about the post/story/reel in detail"
            />
            <Button
              variant="filled"
              style={{ backgroundColor: primaryActionColor, color: "white" }}
              onClick={() => {
                if (isStringNullOrUndefined(context)) {
                  return enqueueSnackbar("Please enter a detailed context", {
                    variant: "error",
                  });
                }
                setBody({ isAi: true, context: context });
                closeDialog();
              }}
            >
              Done
            </Button>
          </AddFlex>
        }
      />
    </>
  );
}

export default ReplyToCommentsAutomationData;
